import React, { useEffect, useRef } from 'react';
import { useNotification } from '../../context/NotificationContext';
import { FaCheck, FaCheckDouble, FaTimes } from 'react-icons/fa';
import { formatDistanceToNow } from 'date-fns';
import './NotificationDropdown.css';

const NotificationDropdown = ({ onClose }) => {
  const { notifications, loading, markAsRead, markAllAsRead, deleteNotification } = useNotification();
  const dropdownRef = useRef(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onClose]);

  const getNotificationIcon = (type) => {
    switch(type) {
      case 'success': return '✓';
      case 'error': return '✕';
      case 'warning': return '⚠';
      case 'task': return '📋';
      default: return 'ℹ';
    }
  };

  const getNotificationColor = (type) => {
    switch(type) {
      case 'success': return 'var(--success-color)';
      case 'error': return 'var(--danger-color)';
      case 'warning': return 'var(--warning-color)';
      case 'task': return 'var(--primary-color)';
      default: return 'var(--text-secondary)';
    }
  };

  return (
    <div className="notification-dropdown" ref={dropdownRef}>
      <div className="notification-dropdown-header">
        <h3>Notifications</h3>
        {notifications.length > 0 && (
          <button onClick={markAllAsRead} className="mark-all-btn">
            <FaCheckDouble /> Mark all read
          </button>
        )}
      </div>

      <div className="notification-list">
        {loading ? (
          <div className="notification-loading">Loading...</div>
        ) : notifications.length === 0 ? (
          <div className="notification-empty">
            <p>No notifications</p>
          </div>
        ) : (
          notifications.map((notif) => (
            <div 
              key={notif._id} 
              className={`notification-item ${!notif.isRead ? 'unread' : ''}`}
            >
              <div 
                className="notification-icon"
                style={{ color: getNotificationColor(notif.type) }}
              >
                {getNotificationIcon(notif.type)}
              </div>
              
              <div className="notification-content">
                <h4>{notif.title}</h4>
                <p>{notif.message}</p>
                <span className="notification-time">
                  {formatDistanceToNow(new Date(notif.createdAt), { addSuffix: true })}
                </span>
              </div>

              <div className="notification-actions">
                {!notif.isRead && (
                  <button 
                    onClick={() => markAsRead(notif._id)}
                    className="notif-action-btn"
                    title="Mark as read"
                  >
                    <FaCheck />
                  </button>
                )}
                <button 
                  onClick={() => deleteNotification(notif._id)}
                  className="notif-action-btn delete"
                  title="Delete"
                >
                  <FaTimes />
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default NotificationDropdown;
